<div class="registration">

  <registration-nav *ngIf="navigationBarActive"></registration-nav>

  <div class="main">
    <router-outlet></router-outlet>
  </div>

</div>
